import { Alert, CircularProgress, Modal, Snackbar, Box, FormControl, InputLabel } from "@mui/material";
import { useState } from "react";
import { BlueHoverButton } from "../../../components/Inputs/BlueHoverButton";
import { style as modalStyle } from "../../../components/Loading/Loading";
import { ErrorHandling } from "../../../components/Errors/Errors";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../../state/slices/userSlice";
import { WhiteInput } from "../../../components/Inputs/InputText";
import servSolicitacaoAcesso from "../../../services/login/servSolicitacaoAcesso";
import stylesArquivarSolic from "./ArquivarSolicitacao.module.css";


const ArquivarSolicitacao = ({ setOpenPopup, recordForEdit, pesquisar }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [openErrorWindow, setOpenErrorWindow] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [mensagemArquivamento, setMensagemArquivamento] = useState("");
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleCloseError = (event, reason) => {
        if (reason  === 'clickaway') {
            setOpenErrorWindow(false);
        }

        setOpenErrorWindow(false);
    }

    const solicitarArquivamento = async () => {
        if (recordForEdit === null) {
            return;
        }

        try {
            setIsLoading(true);

            if(mensagemArquivamento.trim() === '') {
                setOpenErrorWindow(true);
                setErrorMessage("O motivo do arquivamento deve ser preenchido.");
                setIsLoading(false);
                return;
            }

            if(mensagemArquivamento.length < 15) {
                setOpenErrorWindow(true);
                setErrorMessage("O motivo do arquivamento deve conter no mínimo 15 caracteres.");
                setIsLoading(false);
                return;
            }

            if(mensagemArquivamento.length > 4000) {
                setOpenErrorWindow(true);
                setErrorMessage("O motivo do arquivamento deve conter no máximo 4000 caracteres.");
                setIsLoading(false);
                return;
            }

            let id = recordForEdit?.row?.Id || recordForEdit?.Id;

            let dto = {
                CodigoSolicitacao: id,
                Descricao: mensagemArquivamento
            }

            await servSolicitacaoAcesso.ArquivarSolicitacaoPeloResponsavelTecnico(dto);
            
            setIsLoading(false);

            setOpenPopup(false);

            pesquisar();

        } catch (err) {
            setIsLoading(false);

            return ErrorHandling(
                err?.request.status, 
                err?.message, 
                setOpenErrorWindow, 
                setErrorMessage, 
                dispatch, 
                logout, 
                navigate,
                err?.response?.data?.Message
            );
        }
        
    }

    return (
        <div style={{ width: "100%", height: "20%" }}>
            <h4>
                Você deseja arquivar o orçamento de conexão? <br />
                Após o arquivamento, o orçamento só poderá ser acessado para visualização e não estará disponível para uso.
            </h4>
            <div>
                <FormControl variant="outlined" style={{ margin: '20px 0px 20px 35px', width: '90%' }}>
                    <InputLabel htmlFor="solicitacao-motivo-arquivamento" shrink style={{ color: "#B8B8B8" }}>
                        Motivo do arquivamento
                    </InputLabel>
                    <WhiteInput 
                        fullWidth
                        multiline
                        minRows={4}
                        placeholder="Insira um motivo"
                        type="text"
                        id="solicitacao-motivo-arquivamento"
                        onChange={(e) => setMensagemArquivamento(e.target.value)}
                    />
                </FormControl>
            </div>
            <div className={stylesArquivarSolic.homologacaoBotoes}>
                {/* <BlueHoverButton onClick={() => setOpenPopup(false)}>Cancelar</BlueHoverButton> */}
                <BlueHoverButton onClick={solicitarArquivamento}>Arquivar</BlueHoverButton>
            </div>

            <Snackbar open={openErrorWindow} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleCloseError}> 
                    <Alert onClose={handleCloseError} severity="error" sx={{ width: '100%' }}>
                        {errorMessage}
                    </Alert>
            </Snackbar>

            <Modal open={isLoading}>
                <Box style={modalStyle}>
                    <CircularProgress color="inherit" />
                </Box>
            </Modal>
        </div>
    )
}

export { ArquivarSolicitacao };